import { Parser } from "@json2csv/plainjs";
import { RcFile } from "antd/lib/upload";

export const generateCSV = (
  headers: string[] | undefined,
  data: Array<Record<string, unknown>>
) => {
  const parser = new Parser({ header: !!headers });
  return parser.parse(data);
};

export const getBase64 = (file: RcFile) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};
